import { createSlice } from '@reduxjs/toolkit'

export const masterDataPageSlice = createSlice({
  name: 'masterDataPage',
  initialState: {
    value: 0,
    selectedProgramValue: null,
    selectedExceptionCategory: null,
    basePriceCopySelectedOption: {
      typeOfPrice: '',
      copyScreenOption: '',
      selectedVariety: null,
    },
    pricingStorageForAPI: [],
    copyAndDistributePayloadForStorage: {
      storagePriceFlatRateRequestList: [],
      storageWeeklyIncrementRequests: [],
    },
    copyAndDistributeVarietyFieldValuesForBasePrice: [],
    addPricingVarietyOptions: [],
    pepResaleDetailsPricing: {},
  },
  reducers: {
    fetchData: (state, action) => {
      state.masterDataPage = { ...action.payload }
    },
    setSelectedProgramValue: (state, action) => {
      state.selectedProgramValue = action.payload
    },
    setSelectedExceptionCategory: (state, action) => {
      state.selectedExceptionCategory = action.payload
    },
    // removed general settings; provided by useProgram hook
    setPricingStorageForAPI: (state, action) => {
      state.pricingStorageForAPI = action.payload
    },
    setBasePriceCopySelectedOption: (state, action) => {
      state.basePriceCopySelectedOption.copyScreenOption = action.payload.copyScreenOption
      state.basePriceCopySelectedOption.typeOfPrice = action.payload.typeOfPrice
      state.basePriceCopySelectedOption.selectedVariety = action.payload.selectedVariety
    },
    setCopyAndDistributePayload: (state, action) => {
      state.copyAndDistributePayloadForStorage.storagePriceFlatRateRequestList =
        action.payload.storagePriceFlatRateRequestList
      state.copyAndDistributePayloadForStorage.storageWeeklyIncrementRequests =
        action.payload.storageWeeklyIncrementRequests
    },
    setCopyAndDistributeVarietyFieldValuesForBasePrice: (state, action) => {
      state.copyAndDistributeVarietyFieldValuesForBasePrice = action?.payload
    },
    setAddPricingVarietyOptions: (state, action) => {
      state.addPricingVarietyOptions = action?.payload
    },
    setPepResaleDetailsPricing: (state, action) => {
      state.pepResaleDetailsPricing =
        action?.payload?.data?.priceGroupData[0]?.varietyClassifications[0]
    },
  },
})

export const {
  fetchData,
  setSelectedProgramValue,
  setSelectedExceptionCategory,
  setGeneralSettings,
  setCopyAndDistributePayload,
  setCopyAndDistributePayloadForBasePrice,
  setCopyAndDistributeVarietyFieldValuesForBasePrice,
  setPricingStorageForAPI,
  setBasePriceCopySelectedOption,
  setAddPricingVarietyOptions,
  setPepResaleDetailsPricing,
} = masterDataPageSlice.actions

export default masterDataPageSlice.reducer
